import PickerGrade from './PickerGrade.vue'

export default PickerGrade
